export async function handleValidation(targetUrl: string, value: string, controller: AbortController): Promise<IRes> {
    const apiUrl =  targetUrl.replace('%s', value);
    const secureUrl = apiUrl.replace('http://', 'https://');
	const response = await fetch(secureUrl, {
		method: 'GET',
		cache: 'no-cache',
		mode: 'cors',
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
		},
        signal: controller.signal
	})

	const data = await response.json();
	return data;
}

export function checkEmail(email:string): boolean {
	return email.match(/^.+@.+\..+$/) !== null;
}

export function isFilled(content: string): boolean {
	return content.trim().length >= 6;
}

export enum STATUS_USERNAME {
    OK = 0,
    OKE = 16,
    USERNAME_NOT_VALID = 1,
    USERNAME_UNKNOWN_ERROR = 17,
    USERNAME_EXISTS_ALREADY = 2,
}

export enum STATUS_EMAIL {
    OK = 0,
    OKE = 1,
    INVALID_EMAIL = 16,
    BLOCKED_EMAIL = 32,
    UNKNOWN_EMAIL_ERROR = 17,
    UNKNOWN_EMAIL_PROVIDER = 64,
    ALREADY_REGISTERED_EMAIL = 128,
    UNKNOWN_ERROR = 65
}

enum ERROR_USERNAME {
    OK = 'OK',
    USERNAME_EXISTS_ALREADY = 'Username ungültig',
    USERNAME_UNKNOWN_ERROR = 'Username unbekannter Fehler',
}

enum ERROR_EMAIL {
    OK = 'OK',
    OKE = 'OKE',
    INVALID_EMAIL = 'Ungültige E-mail Adresse',
    BLOCKED_EMAIL = 'Geblockte E-mail Adresse',
    UNKNOWN_EMAIL_PROVIDER = 'E-Mail Adresse Domain unbekannt oder Tippfehler',
    ALREADY_REGISTERED_EMAIL = 'E-Mail Adresse wird bereits registriert',
    UNKNOWN_ERROR = 'E-Mail Adresse Domain unbekannt oder Tippfehler'
}



export function handleusernameError(code){
    switch(code){
        case STATUS_USERNAME.USERNAME_EXISTS_ALREADY:
            return ERROR_USERNAME.USERNAME_EXISTS_ALREADY;
        case STATUS_USERNAME.USERNAME_UNKNOWN_ERROR:
            return ERROR_USERNAME.USERNAME_UNKNOWN_ERROR;
        case STATUS_USERNAME.OK:
        case STATUS_USERNAME.OKE:
            return '';
        default:
            return 'Unbekannter Fehler';
    }
}

export function handleEmailError(code){
    switch(code){
        case STATUS_EMAIL.INVALID_EMAIL:
            return ERROR_EMAIL.INVALID_EMAIL;
        case STATUS_EMAIL.BLOCKED_EMAIL:
            return ERROR_EMAIL.BLOCKED_EMAIL;
        case STATUS_EMAIL.UNKNOWN_EMAIL_PROVIDER:
        case STATUS_EMAIL.UNKNOWN_ERROR:
        case STATUS_EMAIL.UNKNOWN_EMAIL_ERROR:
            return ERROR_EMAIL.UNKNOWN_EMAIL_PROVIDER;
        case STATUS_EMAIL.ALREADY_REGISTERED_EMAIL:
            return ERROR_EMAIL.ALREADY_REGISTERED_EMAIL;
        case STATUS_EMAIL.OK:
        case STATUS_EMAIL.OKE:
            return '';
        default:
            return 'Unbekannter Fehler';
    }
}

export interface IRes {
    data: {
        status: STATUS_USERNAME | STATUS_EMAIL,
        userNameSuggestions: string[]
    }
}